import iconFlag from '@gp/assets/svg/icon-flag.svg';
import iconMeeting from '@gp/assets/svg/icon-meeting-gray.svg';
import DatePickerWrapper from '@gp/components/DatePickerWrapper';
import GeneralModal from '@gp/components/GeneralModal';
import NoData from '@gp/components/NoData';
import OperationBtns from '@gp/components/OperationBtns';
import RangePicker from '@gp/components/RangePicker';
import GPSelect from '@gp/components/Select';
import type { IGRAction, MeetingItem } from '@gp/pages/Pipeline/ProjectDetails/Milestone/types';
import { fetchMilestoneMilestoneMeetingEdit } from '@gp/services/milestone';
import { generateUUID } from '@gp/utils/common';
import { useDeepCompareEffect } from 'ahooks';
import classnames from 'classnames';
import moment from 'moment';
import React, { useCallback, useMemo, useState } from 'react';
import { Button, DatePicker, Form, Input } from 'tea-component';
import { DEFAULT_MEETINGS, DEFAULT_MEETINGS_NEW, STATUSOPTIONS, TYPEOPTIONS } from './constants';
import './index.scss';

const MeetingModal = (props: any) => {
  const {
    style,
    className,
    visible = false,
    setVisible,
    milestone,
    value: grActions = [],
    activeMilestone,
    setIsChangeValue,
    onRefreshMilestones,
    projectDetailData,
  } = props;

  const [meetings, setMeetings] = useState<MeetingItem[]>();
  const [submitted, setSubmitted] = useState(false);

  const isErrorStatus = useCallback(
    (submitted: boolean) => {
      let error = false;

      if (meetings?.length) {
        if (submitted) {
          meetings?.forEach((meeting: any) => {
            if (meeting?.status === 1) {
              if (!meeting?.name) {
                error = true;
              }
            } else if (meeting?.source === 1) {
              if (!meeting?.start_date || !meeting?.end_date || !meeting?.name) {
                error = true;
              }
            } else {
              if (!meeting?.date_time || !meeting?.name) {
                error = true;
              }
            }
          });
        }
      }
      return error;
    },
    [meetings, submitted],
  );

  useDeepCompareEffect(() => {
    const listTemp = milestone?.milestone_meetings || [];
    const newMeetingList =
      listTemp?.map((item: any) => {
        return {
          ...item,
          newId: `${item.id}newId`,
          date_time: !item?.start_date || item?.status === 1 ? undefined : moment(item?.start_date),
          start_date: item?.status === 1 ? '' : item?.start_date,
          end_date: item?.status === 1 ? '' : item?.end_date,
        };
      }) || [];
    setMeetings(newMeetingList);
  }, [milestone, visible]);

  const meetingOptions = useMemo(() => {
    return TYPEOPTIONS.map((item: any) => {
      const iconType = item.value === 1 ? iconFlag : iconMeeting;
      return {
        ...item,
        name: item.text,
        icon: iconType,
      };
    });
  }, [TYPEOPTIONS]);

  const handleItemChange = (newId?: string, payload?: Partial<IGRAction>) => {
    if (!newId) return;
    // setSubmitted(false);
    setIsChangeValue?.(true);
    const meetingsIdx = meetings?.findIndex((meeting: any) => meeting?.newId === newId);
    const meeting = meetings?.[meetingsIdx];
    const meetingTmp = { ...meeting, ...payload };
    const meetingsTmp = [
      ...meetings?.slice(0, meetingsIdx),
      meetingTmp,
      ...meetings?.slice(meetingsIdx + 1),
    ];
    setMeetings(meetingsTmp);
  };

  const handleAddMeetingNew = () => {
    setIsChangeValue?.(true);
    const meetingListNew = DEFAULT_MEETINGS_NEW.map((item: any) => {
      const newId = generateUUID();
      return { ...item, newId };
    });
    setMeetings(meetingListNew);
    // setIsEditing(true);
  };
  const handleAddMeeting = () => {
    setIsChangeValue?.(true);
    const newId = generateUUID();
    const meetingTmp = {
      ...DEFAULT_MEETINGS,
      newId,
    };
    const newMeetingList = [...meetings, meetingTmp];
    setMeetings(newMeetingList);
    // setIsEditing(true);
  };

  const handleDeleteMeeting = (newId?: string) => {
    setIsChangeValue?.(true);
    const meetingsTmp = meetings?.filter((item: any) => item?.newId !== newId);
    setMeetings?.(meetingsTmp);
  };

  const handleUpdateMeetingConfirm = async () => {
    setSubmitted(true);
    const listTemp = milestone?.milestone_meetings || [];
    // 如果没添加过，且没增加新数据，提交不做任何处理
    if (listTemp?.length === 0 && meetings?.length === 0) {
      setVisible(false);
      return;
    }
    if (!isErrorStatus(true)) {
      try {
        let meetingsPaIdList = []; // 外部传入的已有的meeting记录的id数组
        let newMeetingList: any = [];
        let toDeleteList = [];
        if (listTemp?.length > 0) {
          meetingsPaIdList = listTemp?.map((item: any) => item?.id);
        }
        // 如果全部删除
        // if (listTemp?.length === 0 && meetings?.length === 0) {
        //   toDeleteList = meetingsPaIdList;
        // } else {
        newMeetingList = meetings?.map((item: any) => {
          let newItem = {
            ...item,
            start_date:
              item.start_date && item.status !== 1
                ? moment(item?.start_date)?.format('YYYY-MM-DD')
                : '',
            end_date:
              item.end_date && item.status !== 1
                ? moment(item?.end_date)?.format('YYYY-MM-DD')
                : '',
          };
          if (item?.source === 2) {
            newItem = {
              ...newItem,
              start_date:
                item.date_time && item.status !== 1
                  ? moment(item?.date_time)?.format('YYYY-MM-DD')
                  : '',
              end_date: '',
            };
          }

          delete newItem.date_time;
          delete newItem.newId;
          delete newItem.update_time;
          delete newItem.update_user;
          delete newItem.create_time;
          return newItem;
        });
        // 通过判断meetingsPaIdList与newMeetingList的id是否一致，来判断是否有删除的数据
        toDeleteList = meetingsPaIdList?.filter((item: any) => {
          return !newMeetingList?.some((newItem: any) => newItem?.id === item);
        });
        // }

        const params = {
          project_id: projectDetailData?.project_id,
          milestone_id: milestone?.milestone_id,
          items: newMeetingList,
          to_delete: toDeleteList,
        };

        if (projectDetailData?.project_id && milestone?.milestone_id) {
          await fetchMilestoneMilestoneMeetingEdit(params);
          onRefreshMilestones?.();
          // deleteSaveParamsByPageKey(pageKeyCur);
          setVisible(false);
        }
      } catch (exception) {
      } finally {
        setSubmitted(false);
      }
    }
  };

  const handleOnClose = () => {
    setVisible(false);
    setSubmitted(false);
  };

  return (
    <GeneralModal
      style={style}
      className={classnames('dbg-pipeline-detail-milestone-meeting-edit-modal', className)}
      title={activeMilestone ? `Edit Meeting/Event (${activeMilestone})` : 'Edit Meeting/Event'}
      modalSize={1000}
      isFont14={true}
      visible={visible}
      disabledConfirm={false}
      onConfirm={handleUpdateMeetingConfirm}
      onClose={handleOnClose}
      content={
        <div className="dbg-meeting-modal-content">
          {meetings?.length === 0 ? (
            <NoData
              className="dbg-project-detail-visual-showcase-nodata"
              text={
                <div className="dbg-meeting-modal-content-empty">
                  <>
                    No meetings. Please{' '}
                    <Button
                      type="link"
                      onClick={() => {
                        handleAddMeetingNew();
                      }}
                    >
                      Add New Meeting/Event.
                    </Button>
                  </>
                </div>
              }
              height={69}
            />
          ) : (
            <>
              <div
                className={classnames('meeting-list', {
                  'dbg-is-error': isErrorStatus(submitted),
                })}
              >
                {meetings?.map((item, index) => {
                  const meetingNewId = item?.newId;
                  const isEndData =
                    Array.isArray(meetings) &&
                    meetings?.length > 0 &&
                    index === meetings?.length - 1;
                  const isScheduled = item?.status === 1;
                  const errorDate = item?.status !== 1 && !item?.date_time;
                  const errorRange = item?.status !== 1 && !item?.start_date && !item?.end_date;

                  return (
                    <Form.Item key={meetingNewId} className="dbg-meeting-modal-item">
                      <GPSelect
                        clearable={false}
                        className={classnames('dbg-meeting-modal-item-source', {
                          'dbg-is-error': isErrorStatus(submitted) && !item?.name,
                        })}
                        value={item?.source}
                        onChange={(value: string) => {
                          handleItemChange(meetingNewId, {
                            source: value,
                          });
                        }}
                        options={meetingOptions}
                      />
                      <Input
                        className={classnames('dbg-meeting-modal-item-input', {
                          'dbg-is-error': isErrorStatus(submitted) && !item?.name,
                        })}
                        placeholder="Please input Name"
                        value={item?.name}
                        maxLength={30}
                        onChange={(payload) => {
                          handleItemChange(meetingNewId, { name: payload });
                        }}
                      />
                      <div className="dbg-project-details-edit-divider">-</div>
                      <GPSelect
                        clearable={false}
                        value={item?.status}
                        onChange={(value: any) => {
                          let newItem = {
                            status: value,
                          };
                          if (value === 1) {
                            newItem = {
                              ...newItem,
                              start_date: '',
                              end_date: '',
                              date_time: '',
                            };
                          }
                          handleItemChange(meetingNewId, newItem);
                        }}
                        options={STATUSOPTIONS}
                      />
                      <div className="dbg-project-details-edit-divider">-</div>
                      {item?.source === 1 ? (
                        <DatePickerWrapper
                          className={classnames('dbg-meeting-modal-item-date-wrapper-date-range', {
                            'dbg-is-error': isErrorStatus(submitted) && errorRange,
                            'dbg-is-disabled': isScheduled,
                          })}
                          label="Day"
                        >
                          <RangePicker
                            placeholder="Select Date"
                            showSelectType={false}
                            disabled={isScheduled}
                            type={'date'}
                            value={{
                              dateType: 'date',
                              startDate: isScheduled ? '' : item?.start_date,
                              endDate: isScheduled ? '' : item?.end_date,
                            }}
                            onChange={(payload) => {
                              handleItemChange(meetingNewId, {
                                start_date: payload?.startDate,
                                end_date: payload?.endDate,
                              });
                            }}
                          />
                        </DatePickerWrapper>
                      ) : (
                        <DatePickerWrapper
                          className={classnames('dbg-meeting-modal-item-date-wrapper-date', {
                            'dbg-is-error': isErrorStatus(submitted) && errorDate,
                            'dbg-is-disabled': isScheduled,
                          })}
                          label="Day"
                        >
                          <DatePicker
                            placeholder="Select Date"
                            value={
                              isScheduled || !item?.date_time ? undefined : moment(item?.date_time)
                            }
                            disabled={isScheduled}
                            onChange={(payload) => {
                              const date = payload?.format('YYYY-MM-DD');
                              handleItemChange(meetingNewId, { date_time: date });
                            }}
                          />
                        </DatePickerWrapper>
                      )}
                      {/* 操作按钮 */}
                      <OperationBtns
                        className="dbg-gr-action-items-form-control__operation-btns"
                        isShowAdd={isEndData}
                        isShowDelete
                        onAdd={handleAddMeeting}
                        onDelete={() => {
                          handleDeleteMeeting(meetingNewId);
                        }}
                      />
                    </Form.Item>
                  );
                })}
                {isErrorStatus(submitted) && (
                  <div className="dbg-form-error-info">
                    Please complete the required fields before confirming.
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      }
    />
  );
};

export default MeetingModal;
